import React, { Component } from "react";
import MessageA1 from "../MessageCodes/MessageA1";
import MessageA2 from "../MessageCodes/MessageA2";
import MessageA13 from "../MessageCodes/MessageA13";
import MessageA5 from "../MessageCodes/MessageA5";
import MessageA6 from "../MessageCodes/MessageA6";
import MessageA14 from "../MessageCodes/MessageA14";
import MessageA15 from "../MessageCodes/MessageA15";
import MessageA19 from "../MessageCodes/MessageA19";
import MessageA20 from "../MessageCodes/MessageA20";
import MessageA21 from "../MessageCodes/MessageA21";
import MessageA3 from "../MessageCodes/MessageA3";
import MessageA4 from "../MessageCodes/MessageA4";
import MessageA56 from "../MessageCodes/MessageA56";
import Redirect from "../MessageCodes/Redirect";
import MessageA78 from "../MessageCodes/MessageA78";
import MessageA79 from "../MessageCodes/MessageA79";
import MessageA77 from "../MessageCodes/MessageA77";
import dayjs from "dayjs";
import MessageA1i from "../MessageCodes/MessageA1i";
import MessageA3f from "../MessageCodes/MessageA3f";
import MessageA97 from "../MessageCodes/MessageA97";
import MessageA98 from "../MessageCodes/MessageA98";
import MessageA99 from "../MessageCodes/MessageA99";
import MessageA96 from "../MessageCodes/MessageA96";
import { isNullOrUndefined } from "../../HWLibrary/HWUtils";
import { s360ConfigService } from "../../Services/S360Config";
import styled from "styled-components";

const ReceivedCardWithTail = styled.div`
  &::before {
    top: ${props => props.$top || '0px'};
    background: ${props => props.$bgColor || 'white'};
  }
`;

class CustomMessage extends Component {
  showMessageTime = () => {
    return this.props.message.type !== MessageType.info;
  };

  messageTimeStyle = () => {
    let config = this.props.config;
    return {
      width: '100%',
      marginRight: '0',
      fontFamily: config.designDetails.messageFont,
      fontSize: config.designDetails.messageTimeFontSize,
      color: config.designDetails.messageTimeFontColor,
      textAlign: config.designDetails.incomingMessageTextAlign || 'left',
    }
  }

  messageCardStyle = () => {
    const config = this.props.config;
    const style = {}
    if (!isNullOrUndefined(config.designDetails?.cardBorderRadius)) {
      style.borderRadius = `${config.designDetails.cardBorderRadius}px`;
      style.borderTopLeftRadius = `0px`;
    }
    if (config.designDetails?.hideCardBoxShadow) {
      style.boxShadow = 'none';
      style.border = "1px solid"
      style.borderColor = isNullOrUndefined(config.designDetails?.buttonBorderColor)
            ? "#0092ed"
            : config.designDetails.buttonBorderColor;
    }

    return style;
  }

  getMessageComponent = (entry, index, sentTimestamp, isLastEntry, A1iCount) => {
    const commandType = entry.uiCommand;

    switch (commandType) {
      case UICommandType.A1:
        return (
          <MessageA1
            switchBot={this.props.switchBot}
            disabled={this.props.disabled}
            key={"message-a1-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      case UICommandType.A1i:
        return (
          <MessageA1i
            disabled={this.props.disabled}
            key={"message-a1i-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            A1iCount={A1iCount}
            {...this.props}
          />
        );
      case UICommandType.A2:
        return (
          <MessageA2
            disabled={this.props.disabled}
            key={"message-a2-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      case UICommandType.A3:
        return (
          <MessageA3
            disabled={this.props.disabled}
            key={"message-a3-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      case UICommandType.A3f:
        return (
          <MessageA3f
            disabled={this.props.disabled}
            key={"message-a3f-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      case UICommandType.A4:
        return (
          <MessageA4
            disabled={this.props.disabled}
            key={"message-a4-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      case UICommandType.A5:
        return (
          <MessageA5
            disabled={this.props.disabled}
            key={"message-a5-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      case UICommandType.A6:
        return (
          <MessageA6
            disabled={this.props.disabled}
            key={"message-a6-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      case UICommandType.A13:
        return (
          <MessageA13
            disabled={this.props.disabled}
            key={"message-a13-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
            scrollToLatest={this.props.scrollToLatest}
          />
        );
      case UICommandType.A14:
        return (
          <MessageA14
            disabled={this.props.disabled}
            scrollToLatest={this.props.scrollToLatest}
            key={"message-a14-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      case UICommandType.A15:
        return (
          <MessageA15
            disabled={this.props.disabled}
            key={"message-a15-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      case UICommandType.A19:
        return (
          <MessageA19
            disabled={this.props.disabled}
            key={"message-a19-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      case UICommandType.A20:
        return (
          <MessageA20
            disabled={this.props.disabled}
            key={"message-a20-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      case UICommandType.A21:
        return (
          <MessageA21
            disabled={this.props.disabled}
            key={"message-a21-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      case UICommandType.A56:
        return (
          <MessageA56
            disabled={this.props.disabled}
            key={"message-a56-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      case UICommandType.A77:
        return (
          <MessageA77
            disabled={this.props.disabled}
            key={"message-a77-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      case UICommandType.A78:
        return (
          <MessageA78
            disabled={this.props.disabled}
            key={"message-a78-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      case UICommandType.A96:
        return (
          <MessageA96
            disabled={this.props.disabled}
            key={"message-a-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      case UICommandType.A97:
        return (
          <MessageA97
            disabled={this.props.disabled}
            key={"message-a97-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      case UICommandType.A98:
        return (
          <MessageA98
            disabled={this.props.disabled}
            key={"message-a98-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      case UICommandType.A99:
        return (
          <MessageA99
            disabled={this.props.disabled}
            key={"message-a99-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      case UICommandType.Redirect:
        return (
          <Redirect
            disabled={this.props.disabled}
            key={"message-redirect-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );

      case UICommandType.A79:
        return (
          <MessageA79
            disabled={this.props.disabled}
            key={"message-a79-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...this.props}
          />
        );
      // closedSession:"closedSession",
      // transferSession:"transferSession"
      default:
        return <></>;
    }
  };

  render() {
    let messageEntries =
      (this.props.message.message.chatResponse &&
        this.props.message.message.chatResponse.entries) ||
      [];
    let sentTimestamp = this.props.message.message.sentTimestamp;
    const A1iCount = messageEntries.reduce((a, c) => a + (c?.uiCommand === "A1i" ? 1 : 0), 0)
    const startsWithA3 = ["A3", "A3f"].includes(messageEntries[0]?.uiCommand);
    const showCardStyleMessages =  !!s360ConfigService.config.designDetails?.showIncomingMessagesInCardStyle
    const tailClass = startsWithA3 && s360ConfigService.config.designDetails?.showMessageTailTriangle ? " s360-message-tail" : "";

    return (
      <div
        className={
          (localStorage.getItem("openInFullScreen")
            ? "s360-dynamic-buttons-fs"
            : "s360-dynamic-buttons") + tailClass
        }
        style={{
          flexDirection: isNullOrUndefined(
            s360ConfigService.config.designDetails.verticalButtons
          )
            ? "row"
            : "column",
          width: isNullOrUndefined(
            s360ConfigService.config.designDetails.verticalButtons
          )
            ? "95%"
            : "85%",
          padding: showCardStyleMessages ? "5px 15px 5px 20px" : '0px'
        }}
      >
        {
          showCardStyleMessages 
            ? 
              // adding a parent div to show whole message in a card, also add time to the bottom
              <ReceivedCardWithTail 
                $bgColor={startsWithA3 ? s360ConfigService.config.designDetails?.senderMessageColor : 'white'}
                $top={s360ConfigService.config.designDetails?.hideCardBoxShadow ? '-1px !important' : '0px'}
                className={`s360-message-card-received ${A1iCount > 0 ? "s360-message-card-received-for-A1i" : ''} ${A1iCount == 4 ? "s360-message-card-received-for-A1i-4-items" : ''}`} 
                style={this.messageCardStyle()} 
              >
                  {messageEntries.map((entry, index, allEntries) => {
                    return this.getMessageComponent(entry, index, null, allEntries.length === index, A1iCount);
                  })}
                  {messageEntries?.length > 0 && sentTimestamp && (
                    <time
                      className="s360-message-time-received"
                      style={this.messageTimeStyle()}
                    >
                      {dayjs
                        .unix(Math.trunc(sentTimestamp / 1000))
                        .format(s360ConfigService.config.designDetails?.messageTimeStampFormat || "DD MMM hh:mm a")}
                    </time>
                  )}
              </ReceivedCardWithTail>
            :
              messageEntries.map((entry, index, allEntries) => {
                return this.getMessageComponent(entry, index, sentTimestamp, allEntries.length === index, A1iCount);
              })
        }
      </div>
    );
  }
}

export const UICommandType = {
  A1: "A1",
  A1i: "A1i",
  A2: "A2",
  A3: "A3",
  A3f: "A3f",
  A4: "A4",
  A5: "A5",
  A6: "A6",
  A10: "A10",
  A13: "A13",
  A14: "A14",
  A15: "A15",
  A19: "A19",
  A20: "A20",
  A21: "A21",
  A24: "A24",
  A56: "A56",
  A78: "A78",
  A79: "A79",
  A77: "A77",
  A96: "A96",
  A97: "A97",
  A98: "A98",
  A99: "A99",
  Redirect: "Redirect",
  closedSession: "closedSession",
  transferSession: "transferSession",
};

export const MessageType = {
  received: "RECEIVED",
  sent: "SENT",
  info: "INFO",
};

export default CustomMessage;
